import ReplayIcon from "@mui/icons-material/Replay";
import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import Zoom from "@mui/material/Zoom";

import useDevMode from "../utils/devmode";

export type Requeue = { reason: string | null; at: string | null };

const hintSx = {
  display: "inline-flex",
  alignItems: "center",
  gap: 0.25,
  ml: 0.5,
  fontSize: 11,
  whiteSpace: "nowrap",
};

export function requeueText({ reason, at }: Requeue): string {
  const text = reason ?? "Waiting, no reason recorded";
  return at ? `Since ${new Date(at).toLocaleString()}: ${text}` : text;
}

export default function RequeueHint({ requeue }: { requeue?: Requeue }) {
  const devMode = useDevMode();
  if (!devMode || !requeue) {
    return null;
  }

  return (
    <Tooltip
      title={requeueText(requeue)}
      TransitionComponent={Zoom}
      placement="top"
      arrow
    >
      <Box
        component="span"
        data-testid="requeuedHint"
        aria-label="requeued"
        sx={{ ...hintSx, color: "warning.main" }}
      >
        <ReplayIcon sx={{ fontSize: 14 }} />
      </Box>
    </Tooltip>
  );
}
